export default __webpack_public_path__ + "static/media/person_1@3x.9da6fb11.png";